import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';
import { createSelector } from '@ngrx/store';
import { SessionTokenState } from 'app/modules/darwin/store/session-token/session-token.state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SessionTokenSelectors {

  static readonly FEATURE = 'SessionToken';

  private readonly feature = createFeatureSelector<SessionTokenState>(
    SessionTokenSelectors.FEATURE
  );

  static readonly token = createSelector(
    createFeatureSelector<SessionTokenState>(SessionTokenSelectors.FEATURE),
    (state: SessionTokenState) => state.token
  );

  private readonly tokenLoaded = createSelector(
    this.feature,
    (state: SessionTokenState) => state.tokenLoaded
  );

  constructor(
    private readonly store: Store<SessionTokenState>
  ) {
  }

  public isSessionTokenLoaded(): Observable<boolean> {
    return this.store.select(this.tokenLoaded);
  }

  public onSessionTokenLoaded(): Observable<boolean> {

    return this.isSessionTokenLoaded()
      .pipe(filter(x => !!x));
  }

  public onValidSessionTokenLoaded(): Observable<boolean> {

    return this.getSessionToken()
      .pipe(map(x => !!x));
  }

  public getSessionToken(): Observable<string> {

    return this.onSessionTokenLoaded()
      .pipe(
        switchMap(() => this.store.select(SessionTokenSelectors.token)),
        filter(token => token?.length > 0),
      );
  }

}
